import React from 'react';

const RightArrowIcon = (props) => {
    const { style, width } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 7.2 12">
            <title>Asset 1</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="info">
                    <path d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                </g>
            </g>
        </svg>
    )
};

export default RightArrowIcon;